import axios from "axios";
import { returnErrors } from "../Redux/ActionCreators/errorAction";

// const AuthStr = "Bearer " + localStorage.getItem("token");
function getAuthHeader() {
  // SHARED MODE → ONLY use shared token
  if (window.isSharedReportMode === true) {
      const copied = localStorage.getItem("share_access_token_copied");
      const email = localStorage.getItem("share_access_token_email");
      const token = copied || email;

      if (!token) return ""; // no fallback to user token
      return `Bearer ${token}`;
  }

  // NORMAL MODE → ONLY use normal token
  const userToken = localStorage.getItem("token");
  return userToken ? `Bearer ${userToken}` : "";
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function getJobApiCall(url, params = {}) {

  return axios
    .get(process.env.REACT_APP_AI_API_KEY + url, {
      headers: {
        Authorization: getAuthHeader(),
        "X-User-Timezone": userTimezone,
      },
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      const status = error?.response?.status;
      const message =
        error?.response?.data?.responseMessages?.[0]?.message ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      return Promise.reject({
        isAxiosError: true,
        parsedStatus: status,
        parsedMessage: message,
        originalError: error,
      });
    });
}

function postJobApiCall(url, body) {
  return axios
    .post(process.env.REACT_APP_AI_API_KEY + url, body, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone,},
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      if (error?.response?.status === 402) throw error;
      if (error?.response?.status === 403) throw error;
      if (error?.response?.status === 409) throw error;
      return error;
    });
}


function putJobApiCall(url, body) {
  return axios
    .put(process.env.REACT_APP_AI_API_KEY + url, body, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone },
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      if (error?.response?.status === 402) throw error;
      returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
    });
}

function deleteJobApiCall(url, body) {
  return axios
    .delete(process.env.REACT_APP_AI_API_KEY + url, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone },
      data: body,
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
    });
}

function getJobApiBlobCall(url) {
  return axios
    .get(process.env.REACT_APP_AI_API_KEY + url, {
      headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone },
      responseType: "blob",
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
    });
}

function patchJobApiCall(url, body) {
  return axios
  .patch(process.env.REACT_APP_AI_API_KEY + url, body, {
    headers: { Authorization: getAuthHeader(), "X-User-Timezone": userTimezone}
  })
  .then((data) => data)
  .catch((error) => {
    returnErrors(
        error.response?.data?.responseMessages?.[0]?.message,
        error?.response?.status
      );
      return error;
  })
}

export {
  getJobApiCall,
  postJobApiCall,
  putJobApiCall,
  deleteJobApiCall,
  getJobApiBlobCall,
  patchJobApiCall,
};
